<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <a nz-button nzType="link" (click)="inputChanged()">
      <img *ngIf="attributes?.img && value" [src]="value" [alt]="title" style="max-height: 3rem">
      <nz-badge [nzCount]="iconTemplate">
        <nz-avatar *ngIf="!value || !attributes?.img" [nzSize]="64" [nzIcon]="attributes?.icon ?? 'user'"
          [nzShape]="attributes?.shape" [nzSrc]="value">
        </nz-avatar>
      </nz-badge>
    </a>
    <br />
    <br />
  </nz-form-control>
</nz-form-item>
<ng-template #iconTemplate>
  <i *ngIf="attributes?.img && !value" class="icmn-cloud-upload ant-scroll-number-custom-component" style="color: #455CC7; font-size: 16px"></i>
  <i *ngIf="attributes?.img && value" class="icmn-bin ant-scroll-number-custom-component" style="color: #455CC7; font-size: 16px"></i>
</ng-template>
